import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25a7a1a2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a7a1a2')) {
      api.createRecord('25a7a1a2', component.options)
    } else {
      api.reload('25a7a1a2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=25a7a1a2&", function () {
      api.rerender('25a7a1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/social-media-posting/index.vue"
export default component.exports